<!-- 1001：客户登记 -->
<template>
     
    <el-card  class="newtable"  style="width:96%;margin-left:auto;margin-right:auto">
        
        <div slot="header" class="clearfix">
            <span v-if="form.isclose"> 案件查看 </span>
            <span v-else> 收案审批 </span>
         
            <el-button type='text' style="float: right; padding: 3px 0;color:black" >填表日期： {{form.createDate}}</el-button>
            <el-button type='text' v-if="form.case_anhao" style="float: right; padding: 3px 0;color:black;margin-right:10px" >案号：{{form.case_anhao}} <span style="margin-left:10px">|</span> </el-button>
      
        </div>
    

        <el-form ref="form" :model="form" label-width="150px" class="formtable">
            
            <div  v-for="(item,client_index) of form.clientinfo"  v-bind:key="client_index">
                <el-col :span="24"   >
                    <div class="tag_item"  >
                        客户信息 {{form.clientinfo.length>1? client_index+1:'' }} 
                        
                         
                    
                    </div>
                </el-col>


                <el-form-item label="*客户名称">
                    <el-col :span="18"   >
                        <el-input readonly v-model="form.clientinfo[client_index].client_name" placeholder="不可输入，请点击 🔍 从自己客户中选择"></el-input>
                    </el-col>
                    <el-col :span="5" style="text-align:center"  >

                    <el-button v-if="mode=='new' || mode=='edit'" icon="el-icon-search" circle  style="margin-left:30px "  @click="GetClientList(client_index)"></el-button>
                    <el-button v-if="(mode=='new' || mode=='edit' || mode=='rewrite')  && client_index==form.clientinfo.length-1" icon="el-icon-plus" circle  style="margin-left:30px"   @click="PlusItem('client')"></el-button>

                    <el-button v-if=" (mode=='new' || mode=='edit' || mode=='rewrite')  &&client_index>0" icon="el-icon-minus" circle   style="margin-left:30px"  @click="DeleteItem('client',client_index)"></el-button>

                    <!-- <el-button v-if="mode=='new' || mode=='edit'" icon="el-icon-search" circle  style="margin-left:30px "  @click="GetClientList(client_index)"></el-button> -->
                        
                    <el-button v-if="isReadOnly" type="primary" plain    icon="el-icon-d-arrow-right" circle  @click="CheckClientDetail(form.clientinfo[client_index].sheet_id)"></el-button>   

                    </el-col>

                </el-form-item>

                <el-form-item label="联系人">
                    <el-col :span="10"  >
                        <el-input :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_contact"  ></el-input>
                    </el-col>
                   
                    <el-col class="line" :span="3"  >  联系方式 </el-col>
                    <el-col :span="10"   >
                        <el-input :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_phone"  ></el-input>
                    
                    </el-col>
                
                </el-form-item>

                <el-form-item label="联系地址">
                    <el-col :span="23"  >
                        <el-input  :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_address"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="是否是自然人">
                    

                    <el-col :span="10">
                        <!-- :disabled="mode=='check' || mode=='examine'" -->
                        <el-switch :disabled="isReadOnly"  v-model="form.clientinfo[client_index].client_isPerson"></el-switch>
                    </el-col>
                    
                    <el-col class="line" :span="3"  v-if="form.clientinfo[client_index].client_isPerson">  身份证 </el-col>
                    <el-col :span="10"  v-if="form.clientinfo[client_index].client_isPerson">
                        <el-input :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_identity"  ></el-input>
                    
                    </el-col>



                </el-form-item>

            </div>
            
            
             

            <!-- <el-divider content-position="center">备注</el-divider> -->

            <el-col :span="24"   >
                <div class="tag_item"  > 
                    <!-- <div style="width:60%">案件信息</div> -->
                    案件信息
                    <!-- <div style="width:40%">案号: {{form.case_anhao}} </div>  -->
                </div>

                <!--  -->

            </el-col>


            <el-form-item label="*案件名称">
                <el-col :span="23"  >
                    <el-input :readonly="isReadOnly" v-model="form.case_name"></el-input>
                </el-col>
            </el-form-item>


            <el-form-item label="*案件类型">
                <el-col :span="10"  >
                   
                    <el-select v-model="form.case_class" placeholder="请选择"  style="width:80%" :disabled="isReadOnly" >
                        <el-option
                            v-for="item in caseType"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-col>
                <!-- margin-left:20px; -->
                <el-col class="line" :span="3"  >  案由 </el-col>
                <el-col :span="10"   >
                    <el-input :readonly="isReadOnly" v-model="form.case_cause"  ></el-input>
                
                </el-col>
            
            </el-form-item>

            <el-form-item label="*收案日期">
                <el-col :span="10"  >
                    <el-date-picker
                        :disabled="isReadOnly" 
                        style="width:80%"
                        value-format="yyyy-MM-dd"
                        v-model="form.case_open_date"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-col>
                <!-- margin-left:20px; -->
                <el-col class="line" :span="3"  > 代理审级 </el-col>

                <el-col :span="10"   >
                    <el-select v-model="form.case_stage" placeholder="请选择"   style="width:100%"  :disabled="isReadOnly">
                        <el-option label="一审" value="一审"> 一审  </el-option>
                        <el-option label="二审" value="二审" > 二审  </el-option>
                        <el-option label="一审和二审" value="一审和二审">  一审和二审  </el-option>
                        <el-option label="再审一审" value="再审一审" > 再审一审  </el-option>
                        <el-option label="再审二审" value="再审二审" > 再审二审  </el-option>

                    </el-select>
                </el-col> 

                <!-- dailishenji: ['一审', '二审', '一审和二审','再审一审', '再审二审'], -->
                <!-- <el-col :span="10"   >
                     <el-date-picker
                        :disabled="mode!='edit'"
                        v-model="form.case_close"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                
                </el-col> -->
            
            </el-form-item>

<!-- 
:active-value="1"
    :inactive-value="0" -->
      <!-- <el-switch :disabled="mode=='check' || mode=='examine'"  v-model="form.clientinfo[client_index].client_isPerson"></el-switch> -->
            <el-form-item label="是否结案">
            
                <el-col :span="10">                    
                    <el-switch :disabled="mode!='edit'"  v-model="form.is_case_close" :active-value="1"   ></el-switch>
                    <span v-if="mode=='new' || mode=='rewrite'  "  style="margin-left:10px;color:gray"> 由管理员填写</span>
                </el-col>
            
                <el-col class="line" :span="3"  v-if="form.is_case_close">  结案日期 </el-col>
                <el-col :span="10"  v-if="form.is_case_close">
                    <el-col :span="10"   >
                     <el-date-picker
                        value-format="timestamp"
                        :disabled="mode!='edit'"
                        v-model="form.case_close_date"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                
                </el-col>
                
                </el-col>

            </el-form-item>


            <el-form-item label="实际到账">
            
                <!-- <el-col :span="10">                    
                    <el-input  :disabled="mode!='edit'"  v-model="form.fee_got"  ></el-input>
                    <span v-if="mode=='new' || mode=='rewrite'  "  style="margin-left:10px;color:gray; "> 由管理员填写</span>
                </el-col> -->

                <el-col :span="10"  >
                    <el-input :disabled="mode!='edit'" type="number"  v-model="form.case_fee_got" style="width:80%" ></el-input>
                </el-col>
            
                <el-col class="line" :span="3"   >  已开票金额 </el-col>

                <el-col :span="10"  >
                    <el-input :disabled="mode!='edit'"  type="number"  v-model="form.invoice_amount"  ></el-input>
                </el-col>
               
                <!-- <el-col :span="10"  v-if="form.is_case_close">
                    
                     <el-date-picker
                        :disabled="mode!='edit'"
                        v-model="form.case_close_date"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                
                </el-col> -->
                
              

            </el-form-item>




            <div  v-if="form.case_class=='常年法律顾问'">
                <el-form-item label="顾问期限"  >
                    <el-col :span="10"  > 
                    
                        <!-- <el-select v-model="form.case_class" placeholder="请选择"  style="width:80%">
                            <el-option
                                v-for="item in caseType"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select> -->

                        <el-date-picker
                            :readonly="isReadOnly"
                            style="width:100%"
                            value-format="timestamp"
                            v-model="form.startDate"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>


                    </el-col>
                    <!-- margin-left:20px; -->
                    <el-col class="line" :span="3"   >  至 </el-col>
                    <el-col :span="10"   >
                        <el-date-picker
                            :readonly="isReadOnly"
                            style="width:100%"
                            value-format="timestamp"
                            v-model="form.endDate"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    
                    </el-col>
                
                </el-form-item>


                <el-form-item label="是否设置总时长">
                    <!-- <el-switch v-model="form.isPerson"></el-switch> -->

                    <el-col :span="10">
                        <!-- <el-input v-model="form.contactman"  ></el-input> -->
                        <el-switch :disabled="mode=='check' || mode=='examine'" v-model="form.case_charge_by_time"></el-switch>
                    </el-col>
                
                </el-form-item>



                <el-form-item label="工作时长（分）" v-if="form.case_charge_by_time">
                    <el-col :span="10"  >
                        <el-input :readonly="isReadOnly" v-model="form.case_prepare_hour"  type="number" ></el-input>
                      
                    </el-col>
                    <!-- margin-left:20px; -->
                    <el-col class="line" :span="3"  > 已工作时长（分） </el-col>
                    <el-col :span="10"   >
                        <el-input :readonly="isReadOnly" v-model="form.case_charge_hour"   type="number"></el-input>
                    
                    </el-col>
            
                </el-form-item>



            </div>


           












            <el-form-item label="*收费方式">
                <el-col :span="10"  >
              
                    <el-select v-model="form.case_shoufei" placeholder="请选择"  style="width:80%" :disabled="isReadOnly" >
                        <el-option label="预付费" value="预付费"> 预付费  </el-option>
                        <el-option label="风险代理" value="风险代理"  v-if="form.case_class!='常年法律顾问'  &&  form.case_class!='刑事辩护' "> 风险代理  </el-option>
                        <el-option label="分阶段收费" value="分阶段收费">  分阶段收费  </el-option>


                        <!-- 预付费','风险代理','分阶段收费 -->

                        <!-- <el-option
                            v-for="item in charge"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option> -->

                    </el-select>
                </el-col>
                <!-- margin-left:20px; -->
                <el-col class="line" :span="3"  >  *合同收费{{form.case_shoufei=='风险代理'?'比例':'金额' }}  </el-col>
                <el-col :span="10"   >
                    <el-input :readonly="isReadOnly" v-model="form.case_fee"  ></el-input>
                
                </el-col>
            
            </el-form-item>


            <el-form-item label="收费阶段"  v-if="form.case_shoufei==charge[1] || form.case_shoufei==charge[2] " >
                <el-col :span="23"  >
                    <el-input :readonly="isReadOnly" v-model="form.case_shoufei_stage"></el-input>
                </el-col>
            </el-form-item>


            <el-form-item label="*案件归属"   >


     
                <!-- <div v-if="mode=='new' || mode=='edit' || mode=='rewrite' ">
                    <el-col :span="8"  >
                        <el-select
                            style="width:80%"
                            clearable
                            @keyup.enter.native="handleSelectConfirm2()"
                            @change="handleSelectConfirm2()"
                            v-model="selectValue1"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入姓名搜索"
                            :remote-method="remoteMethod"
                            :loading="loading">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item">
                            </el-option>
                         
                        </el-select>

    
                    </el-col>

                    <el-col :span="2" v-if="form.case_belong">
                        <i class="el-icon-check" style="color:green;font-size:16px"></i>
                    </el-col>

                </div> -->

                <el-col :span="10" v-if="mode=='new' || mode=='edit' || mode=='rewrite' " >
                    <el-select
                        style="width:80%"
                        clearable
                        @keyup.enter.native="handleSelectConfirm2()"
                        @change="handleSelectConfirm2()"
                        v-model="form.case_belong"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入姓名搜索"
                        :remote-method="remoteMethod"
                        :loading="loading">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item">
                        </el-option>
                        <!-- :value="item.value" -->
                    </el-select>


                </el-col>
                
                    


                <el-col :span="10" v-else>
                    <el-input v-if="form.case_belong" :readonly="isReadOnly" v-model="form.case_belong.name"   style="width:80%" ></el-input>
                    <el-input v-else  disabled    style="width:80%"></el-input>
                </el-col>

                <el-col class="line" :span="3"  >  是否有分成律师  </el-col>

                <el-col :span="10">
           
                    <el-switch :disabled="mode=='check' || mode=='examine'" v-model="form.case_isfeeshare"></el-switch>
                </el-col>

            </el-form-item>



            <!-- <el-form-item label="是否有分成律师">
                <el-col :span="10">
                    <el-switch :disabled="mode=='check' || mode=='examine'" v-model="form.case_isfeeshare"></el-switch>
                </el-col>
               
            </el-form-item> -->


            <el-form-item label="分成人员"  v-if="form.case_isfeeshare">
                <!-- <el-switch v-model="form.isPerson"></el-switch> -->

                <el-col :span="10" v-if="mode=='new' || mode=='edit' || mode=='rewrite' ">
                    <!-- <el-input v-model="form.whoshare"  ></el-input> -->

    
                    <el-select
                        style="width:80%"
                        clearable
                        @keyup.enter.native="handleSelectConfirm()"
                        @change="handleSelectConfirm()"
                        v-model="form.whoshare"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入姓名搜索"
                        :remote-method="remoteMethod"
                        :loading="loading">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item">
                        </el-option>
                        <!-- :value="item.value" -->
                    </el-select>



 
                   
                </el-col>


                <el-col :span="10" v-else>
                    <el-input readonly v-model="form.whoshare.name"  ></el-input>
                </el-col>

                <!-- <el-col :span="2" style="text-align:center"  >
             
                    <el-button v-if="mode=='new' || mode=='edit'" icon="el-icon-search" circle  style="margin-left:30px "  @click="GetStaffList"></el-button>
                        
                </el-col> -->


                <!-- style=" text-align:right;padding-right:10px" -->
                <el-col class="line" :span="3"   >  分成比例(%) </el-col>
                <el-col :span="10"  >
                    <el-input :readonly="isReadOnly" v-model="form.case_share_ratio"  ></el-input>
                
                </el-col>



            </el-form-item>


            <el-form-item label="是否同时申请盖章"  >
                
                <el-col :span="10">
                    <el-switch :disabled="mode=='check' || mode=='examine'" v-model="form.need_seal"></el-switch>
                </el-col>
                <el-col class="line" :span="3"  v-if="form.need_seal" >  文件选择 </el-col>
                <el-col :span="10" v-if="form.need_seal" >
                    <el-checkbox-group v-model="form.seallist"    :disabled="mode=='check' || mode=='examine'"  >
                        <el-checkbox label="委托合同"></el-checkbox>
                        <el-checkbox label="诉讼所函"></el-checkbox>
                        <el-checkbox label="介绍信"></el-checkbox>
                        <!-- <el-checkbox label="禁用" disabled></el-checkbox>
                        <el-checkbox label="选中且禁用" disabled></el-checkbox> -->
                    </el-checkbox-group>
                </el-col>
              
            </el-form-item>

            <el-form-item label="*合同附件"  >
             
                <!-- <el-col :span="10" v-if="mode=='new' || mode=='edit' || mode=='rewrite'">
            
                    <el-upload
                    class="upload-demo"
                    :file-list="form.fileList"
                    drag
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.pdf,.docx,.doc"
                    with-credentials
                    :data="uploadData"
                    :on-success="handleUploadSuccess"
                    :before-upload="handleUploadbefore"
                    :on-remove="handleRemove"
                    action="https://api.lawtip.cn/oa_upload"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png/word/pdf文件，每个文件不超过5M</div>
                    </el-upload>

                   
                </el-col> -->

                <!-- :file-list="form.fileList" -->
                <!-- :on-remove="handleRemove" -->
                <!-- :disabled="mode" -->
                <!-- :span="23" -->
                
       
                   




            <!-- mark -->
                <!-- mode=='rewrite' 这里要去掉，模型要改，否则无法连续添加多张，而且会跳闪，客户感知不好 -->
                <el-col  :span="23" v-if="mode=='new' || mode=='rewrite'  || mode=='edit'  ">
                    <el-upload
                        multiple
                        :action="this.$root.rootUrl+'oa_upload'"
                        list-type="picture-card"
                        with-credentials
                        :data="uploadData"
                        :on-success="handleUploadSuccess"
                        :before-upload="handleUploadbefore"
                        :file-list="mode=='check'||mode=='examine'  ? form.fileList: file_list"
                        :on-change="handleChange"
                        :disabled="mode!='new' && mode!='rewrite'" 
                        ref="upload"
                        >
                            <i  slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}" style="display:flex;flex-direction:column">
                                <!-- <img
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url" :alt="file.name"
                                > -->
                                <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                                <img v-if='file.name.indexOf(".pdf")!=-1' src="@/assets/images/PDF.png"  :alt="file.name"  class="el-upload-list__item-thumbnail"> 
                                <img v-else-if='file.name.indexOf(".doc")!=-1' src="@/assets/images/word.png" :alt="file.name" class="el-upload-list__item-thumbnail"> 
                                <img v-else-if='file.name.indexOf(".xlsx")!=-1 || file.name.indexOf(".csv")!=-1' src="@/assets/images/excel.png" :alt="file.name"   class="el-upload-list__item-thumbnail"> 
                                <img v-else-if='file.name.indexOf(".ppt")!=-1 || file.name.indexOf(".pptx")!=-1' src="@/assets/images/ppt.png" :alt="file.name" class="el-upload-list__item-thumbnail">  
                                <img v-else :src="file.url || file.tempLink " :alt="file.name"   class="el-upload-list__item-thumbnail">
                                <!-- @click="CheckFile(file)" -->


                                <span class="el-upload-list__item-actions">
                                    <span
                                        v-if="(/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(file.name)"
                                    class="el-upload-list__item-preview"
                                     @click="handlePictureCardPreview(file)" 
                                    >
                                    <i class="el-icon-zoom-in"></i>
                                    </span>

                                    <span
                                    class="el-upload-list__item-delete"
                                    @click="handleDownload(file)"
                                    >
                                        <i class="el-icon-download"></i>
                                    </span>
                                    
                                    <span
                                    v-if="mode=='new' || mode=='rewrite'"
                                    class="el-upload-list__item-delete"
                                    @click="handleRemove(file)"
                                    >
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>

                                <span style="position:absolute;bottom:2px;text-align:center;width:100%;line-height:14px ">
                                    <p>{{file.name}}</p>
                                </span>

                            </div>
                    </el-upload>


                     

                </el-col>
                

                <affix_box v-else :affixfileList="form.fileList"> </affix_box>

                <!-- <el-col v-else :span="23"    class="affix_wrap"  >
                    <div class="affix_box"  v-for="(item) of form.fileList"   :key="item.id">
                        <div class="up">  
                            
                            <img v-if='item.fileName.search(/\.pdf/i)!=-1' src="@/assets/images/PDF.png" alt="" @click="OpenFile(item.tempLink)"> 
                            <img v-else-if='item.fileName.search(/\.doc/i)!=-1  ' src="@/assets/images/word.png" alt="" @click="OpenFile(item.tempLink)"> 
                            <img v-else-if='item.fileName.search(/\.xls/i)!=-1 || item.fileName.indexOf(".csv")!=-1' src="@/assets/images/excel.png" alt="" @click="OpenFile(item.tempLink)"> 
                            <img v-else-if='item.fileName.search(/\.ppt/i)!=-1  ' src="@/assets/images/ppt.png" alt="" @click="OpenFile(item.tempLink)">  

                            <img v-else-if="isImg(item.fileName)" :src="item.tempLink" :alt="item.fileName" @click="CheckFile(item)">
                            <img v-else  src="@/assets/images/unknowfile.png" :alt="item.fileName"  @click="OpenFile(item.tempLink)">


                        </div>
                        <div class="down">{{item.fileName}}  </div>

                        
                    </div>
                </el-col> -->


                <!-- v-else :span="23"  -->
         

                <!-- <el-dialog :visible.sync="dialogVisible"  custom-class="detail_dia"    top='5vh' >
                    <img   style="max-width:100%;height:auto" :src="dialogImageUrl" alt=""  >
                </el-dialog> -->
 
                <!-- <div v-else>
                    <el-upload
                        action="#"
                        list-type="picture-card"
                        :auto-upload="false">
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}">
                                <img
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url" alt=""
                                >
                                <span class="el-upload-list__item-actions">
                                    <span
                                    class="el-upload-list__item-preview"
                                
                                    >
                                    <i class="el-icon-zoom-in"></i>
                                    </span>

                                    <span
                                    v-if="!disabled"
                                    class="el-upload-list__item-delete"
                            
                                    >
                                    <i class="el-icon-download"></i>
                                    </span>
                                    <span
                                    v-if="!disabled"
                                    class="el-upload-list__item-delete"
                                
                                    >
                                    <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                    </el-upload>

                </div> -->

                <!-- <el-col class="line" :span="3"   >  附件清单 </el-col> -->

                <!-- <el-col :span="23">
                    <el-checkbox-group v-model="form.seallist">
                        <el-checkbox label="委托合同"></el-checkbox>
                        <el-checkbox label="诉讼所函"></el-checkbox>
                        <el-checkbox label="介绍信"></el-checkbox>
                    
                    </el-checkbox-group>
                </el-col> -->
              
            </el-form-item>



            <el-form-item label="备注信息">
                <!-- <el-input v-model="form.remarks"></el-input> -->
                <el-col :span="23" >
                <el-input
                    type="textarea"
                    :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.remarks">
                </el-input>
                </el-col>
            </el-form-item>


            <div v-if="form.case_class!='常年法律顾问' && form.case_class!='刑事辩护'">
                <div  v-for="(_item,oppo_index) of form.oppositeinfo"   :key="'info2-'+oppo_index">
                    <el-col :span="24"   >
                        <div class="tag_item"  >
                            <!-- <div style="width:50%">对方当事人信息 {{form.oppositeinfo.length>1? oppo_index+1:'' }} </div> -->

                            <el-col :span="12"   >
                                对方当事人信息 {{form.oppositeinfo.length>1? oppo_index+1:'' }}
                            </el-col>


                            <div  class="interest_conflict_style_box"  v-if="oppo_index==0"> 
                                <el-button size="mini" type="warning"  class="interest_conflict_style" @click.native="InterestConflictCheck">利冲检查</el-button> 
                                <!-- <div   class="interest_conflict_style" @click="InterestConflictCheck"> 利冲检查 </div> -->
                            </div>
                            
                        </div>

                        
                    </el-col>

                    <el-form-item label="*名称">
                        <el-col :span="20"   >
                            <el-input  :readonly="isReadOnly"  v-model="form.oppositeinfo[oppo_index].opposite_name"></el-input>
                        </el-col>

                        <el-col :span="3" style="text-align:center"  >
                            <el-button v-if=" (mode=='new' || mode=='edit' || mode=='rewrite')  && oppo_index==form.oppositeinfo.length-1" icon="el-icon-plus" circle   @click="PlusItem('opposite')"></el-button>

                            <el-button v-if=" (mode=='new' || mode=='edit' || mode=='rewrite')  && oppo_index>0" icon="el-icon-minus" circle   style="margin-left:30px"  @click="DeleteItem('opposite',oppo_index)"></el-button>
    
                        </el-col>
                
                    </el-form-item>

                    <el-form-item label="是否是自然人">
                
                        <el-col :span="10">                    
                            <el-switch :disabled=" mode=='check' ||  mode=='examine'" v-model="form.oppositeinfo[oppo_index].opposite_isPerson"></el-switch>
                        </el-col>
                    
                        <el-col class="line" :span="3"  v-if="form.oppositeinfo[oppo_index].opposite_isPerson">  身份证 </el-col>
                        <el-col :span="10"  v-if="form.oppositeinfo[oppo_index].opposite_isPerson">
                            <el-input  :readonly="isReadOnly"  v-model="form.oppositeinfo[oppo_index].opposite_identity"  ></el-input>
                        
                        </el-col>

                    </el-form-item>


                </div>

            </div>
             

            <el-drawer
            title="可能的利冲客户(最多显示前20)"
            :visible.sync="int_drawer"
            :with-header="true">
            <!-- <span>我来啦!</span> -->
                <el-table 
                        :data="conflict_list"

                        style="width: 95%;min-height:700px">
                        <el-table-column
                            label="编号"
                            width="50"
                            type="index">
                            <!-- {{index}} -->
                        </el-table-column>
                        <el-table-column
                            prop="form.client_name"
                            label="姓名"
                            width="120">
                        </el-table-column>
 

                        <el-table-column
                            label="创建日期"
                            width="140">
                            <template slot-scope="scope">
                                <span>
                                    {{timestampToTime(scope.row.createtime)  }}
                                </span>
    
                            </template>  
                        </el-table-column>

                        <el-table-column
                            label="是否自然人"
                            width="140">
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.form.client_isPerson? '是':'否' }}
                                </span>
    
                            </template>  
                        </el-table-column>

                        <el-table-column
                            prop="form.client_identity"
                            label="身份标识"
                            width="160">
                        </el-table-column>
             

         

     
                    </el-table>



            </el-drawer>
            


   


            



            <!-- <el-form-item label="备注信息">
             
                <el-col :span="23" >
                <el-input
                    type="textarea"
                    :disabled="this.mode=='check' || this.mode=='examine'"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.remarks">
                </el-input>
                </el-col>
            </el-form-item> -->

            <el-form-item v-if="mode=='new' ||  mode=='edit' || mode=='rewrite' ">
                <el-col :span="11" >
                    <el-button type="primary" @click="NewFormSubmit" style="margin:auto;width:150px">提交</el-button>
                    <!-- <el-button style="margin:auto">取消</el-button> -->
                </el-col>

                <el-col :span="11" >
                    <!-- <el-button type="primary" @click="onSubmit" style="margin:auto">立即创建</el-button> -->
                    <el-button style="margin:auto;width:150px"   @click="CancelForm"  >取消</el-button>
                </el-col>


            </el-form-item>  

    



        
        </el-form>


    

    </el-card>

</template>

<script>
    function getNum() {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
            'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
            'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
            'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
            'x', 'y', 'z'];
        var nums = "";
        for (var i = 0; i < 8; i++) {
            var id = parseInt(Math.random() * 61);
            nums += chars[id];
        }
        return nums;
    }

  
    function check_must_field(obj,filed_arr){
                // field_check:[
        
    //     { filed:'case_name', },
    //     { filed:'clientinfo', attr: 'arr', poField:'client_name' },
    //     { filed:'case_class', attr: '', },
    //     { filed:'case_open_date', },
    //     { filed:'case_belong',  attr: 'dic',  poField:'staff_id'   },
    //     { filed:'case_shoufei', },
    //     { filed:'case_fee', },
    //     { filed:'fileList', attr: 'arr', poField:'fileLink' },
            
    //     // { filed:'oppositeinfo', attr: 'arr', poField:'client_name' },


    // ]
        // field_check
        for(let p of filed_arr){
            if(!p.attr){
                if( !obj[p.filed] ){
                    return {'status':'fail','err_field': p.filed,'info': p.info }
                } 
            }else if( p.attr && p.attr=='dic'  ){
                if( !obj[p.filed] ||  !obj[p.filed][p.poField]  ){

                    return {'status':'fail','err_field': p.filed,'info': p.info }
                } 
                    
            }else if( p.attr && p.attr=='arr'  ){
                if(obj[p.filed].length==0){
                    return {'status':'fail','err_field': p.filed,'info': p.info }
                }
                for( let q of obj[p.filed] ){
                    if(!q[p.poField]){
                        return {'status':'fail','err_field': p.filed,'info': p.info }

                    }


                }
                // if( !obj[p.filed] ||  !obj[p.filed][p.poField]  ){

                //     return {'status':'fail','err_field': p.filed,'info': p.info }
                // } 
                    
            }



        }

        return {'status':'ok'  }



    }

    import affix_box from '@/components/oa/functions/affix_box.vue'

	export default {
        name: 'template_1002',
        props: {
            form:Object,
            mode:String,
        },
        components: { 
   
            affix_box
   
 
        },
        data() {
			return {
              caseType:['民事诉讼','刑事辩护','刑事附带民事','非诉案件','仲裁案件' ,'执行案件' ,'行政诉讼','常年法律顾问','国家赔偿' ],       
              charge:['预付费','风险代理','分阶段收费'],

                uploadData:{
                    'whattodo':"upLoadFiles"
                },
                isReadOnly:false,
                file_list:[],

                dialogImageUrl:'',
                dialogVisible:false,

                options:[],
                search_list:[],
                loading: false,

                selectValue:'',
                selectValue1:'',
                int_drawer:false,
                conflict_list:[],

                field_check:[
            
                    { filed:'case_name', info:'案件名称不能为空' },
                    { filed:'clientinfo', attr: 'arr', poField:'client_name', info:'客户名称不能为空' },
                    { filed:'case_class',  info:'案件类型不能为空' },
                    { filed:'case_open_date',  info:'收案日期不能为空' },
                    { filed:'case_belong',  attr: 'dic',  poField:'staff_id' , info:'案件归属不能为空'   },
                    { filed:'case_shoufei',info:'收费信息不能为空'  },
                    { filed:'case_fee', info:'合同收费金额不能为空'  },
                    { filed:'fileList', attr: 'arr', poField:'fileLink' , info:'合同附件不能为空'  }, 
              
                     
                    // { filed:'oppositeinfo', attr: 'arr', poField:'client_name' },
  

                ]

			}
        },
        mounted() {
            // console.log('template_id 12 start mode:',this.mode)

 
            let t=setInterval(()=>{
                if(this.mode){
                    clearInterval(t)
                    if(this.mode=='new'){
                        this.form.case_isfeeshare=false
                    }
                
                    if(this.mode!='new' && this.mode!='edit' && this.mode!='rewrite'){
                    this.isReadOnly=true

                    }


                    if(this.mode=='rewrite' && this.form.fileList && this.form.fileList.length>0){

                        this.file_list=this.form.fileList 
                        console.log('=======================this.file_list:',this.file_list)

                        
                    }

                }


            },500)

             

      
       

     

            // this.screenWidth = document.body.clientWidth;
            // this.screenHeight = document.body.clientHeight;
            // window.onresize = () => {
            //     return (() => {
            //         window.console.log('document.body.clientWidth:',document.body.clientWidth)
            //         window.console.log('document.body.clientHeight:',document.body.clientHeight)
                   
            //         this.screenWidth = document.body.clientWidth;
            //         this.screenHeight = document.body.clientHeight;
            //         if (document.body.clientWidth<=1100){
            //             this.rightOnShow=false
            //         }else{
            //              this.rightOnShow=true
            //         }

            //     })();
            // };
        },
        updated(){
            // console.log('update function=====')
       
        },
        methods: {
            
            timestampToTime(timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                // var h = date.getHours() + ':';   //
                // var m = date.getMinutes() + ':';//
                // var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
                return Y + M + D ;  //+ h + m + s
            },
            
            NewFormSubmit(){  //field_check
                console.log('1001 NewFormSubmit emit')
                let obj={"template_id":"1002" , "sheet_name":"收案审批表" }
                this.form.formname=this.form.case_name
                let check=check_must_field(this.form,this.field_check)
                if(check.status=='fail'){
                    this.$message({
                        message: check.info,
                        type: 'warning',
                        duration:4000, 
                        showClose:true, 
                    });
                    return

                }

                if(this.form.case_class!='常年法律顾问' && this.form.case_class!='刑事辩护'){

                    if(this.form.oppositeinfo.length==0 || !this.form.oppositeinfo[0].opposite_name){
                        this.$message({
                            message: '对方当事人名称不能为空',
                            type: 'warning',
                            duration:4000, 
                            showClose:true, 
                        });
                        return

                    }

                    //   caseType:['民事诉讼','刑事辩护','刑事附带民事','非诉案件','行政诉讼','常年法律顾问','国家赔偿' ],     
                    // form.case_class!='常年法律顾问' && form.case_class!='刑事辩护'



                }


                console.log('check:',check)
                console.log('this.form:',this.form)
                // return
                this.$emit('SubmitNewForm',obj); 
            },
            CancelForm(){
                window.close();

            },

            GetClientList(index){
                this.$emit('GetClientList',index);  
            },

            PlusItem(item){
                this.$emit('PlusItem',item); 
            },

            DeleteItem(item,index){
                let obj={item:item,ind:index}
                this.$emit('DeleteItem',obj); 
            },


            SetForm(){
                console.log('-------------- set form')
                this.$emit('SetForm'); 
            },



            handleUploadbefore(file){
             
                console.log("handleUploadbefore start file:",file)
                const fileType = file.type  ;
                const isLt50M = file.size < 50*1024*1024 ;
                if (!isLt50M){
                    this.$message.error('上传文件大小不能超过50MB!');
                }
                // if(!fileType){
                //   this.$message.error('不能上传目录!');
                // }

                console.log("fileType:",fileType)
                window.console.log(isLt50M)
                if(isLt50M){  //&&fileType
                    // this.uploadData={
                //   'id':guid2(),
                //   'whattodo':"upLoadFiles",
                //   'articleId':this.article.docid
                // }
                    this.uploadData.name=file.name
                    this.uploadData.flow_id=this.form.flow_id
                    
                    // window.console.log('this.uploadData:',this.uploadData)
                    this.uploadData.whattodo="upLoadFiles"
                    // this.uploadData.articleId=this.article.docid
                    // this.uploadData.id=file.uid
                    return isLt50M  //&&fileType;
                }else{
                    console.log("不满足上传条件")
                    return false
                }

            },



            handleUploadSuccess(res, file){
                // let a = URL.createObjectURL(file.raw);
                console.log('mode:',this.mode)
                window.console.log('upload success res: ',res)

                
                // window.console.log('file_list:',this.file_list)
                window.console.log('upload success file: ',file)
                if (res.status=='ok'){
                    let obj={
                    "name":res.fileName,
                    'fileName':res.fileName,
                    'fileLink':res.fileLink,
                    'lastModified':file.raw.lastModified,
                    'id':res.id,
                    'tempLink':file.url
                    // "url":file.url
                    }
                    window.console.log('obj: ',obj)
                    // this.article.files.push(obj)
                    // this.Add2FileList(obj)
                    this.form.fileList.push(obj)

                    // this.file_list.push(obj)

                    console.log("file_list:",this.file_list)
                    console.log(" this.form.fileLis:", this.form.fileList)
                    // this.form.fileList=this.fileList



                }else if(res.status=='fail'){
                    if(res.errCode==4005){
                        this.$message({
                            type: 'info',
                            message: '不能上传超过5个文件噢'
                        }); 
                    }else if(res.errCode==4002){
                        this.$message({
                            type: 'info',
                            message: '文件大小合计不能超过5M'
                        }); 
                    }else if(res.errCode==4001){
                        this.$message({
                            type: 'info',
                            message: '文件为空'
                        }); 
                    }

                }
            


            },


            // handleRemove(file) {
            //     console.log(file);
            // },
            handlePictureCardPreview(file) {
                console.log("handlePictureCardPreview file:",file)
                this.dialogImageUrl = file.url || file.tempLink ;
                this.dialogVisible = true;






            },


            CheckFile(item){

                console.log('check file item:',item)
               
                this.dialogImageUrl = item.tempLink ;
                this.dialogVisible = true;

                // window.open(item.tempLink)


            },

            OpenFile(tempLink){
                console.log('OpenFile--------')
                window.open(tempLink, "_blank")

            },

            
            ShowBigPicErr(){
                console.log('ShowBigPicErr')

            },


            handleDownload(file) {
                console.log(file);
                window.open(file.url || file.tempLink )
            },



            Add2FileList(obj){
                this.$emit('Add2FileList',obj); 


            },
            
            DeleteFromFileList(obj){
                this.$emit('DeleteFromFileList',obj); 
            },
            DeleteFromFileList2(file){
                let id=file.response.id
                console.log('this.form.fileList:',this.form.fileList)
            
                console.log('id:',id)
                var ind=this.form.fileList.findIndex((value)=>value.id==id);

                // var ind=this.form.fileList.find((value,index,arr)=>{
                //     if(value.id==id){
                //         return index
                //     }
                // });

                console.log('ind:',ind)
                if(ind!=-1){
                    this.form.fileList.splice(ind,1)
                }
            },


            handleRemove(file) {
                console.log('handleRemove ++++++++++',file);


                var that=this
                var datas= { 
                    fileLink:file.response.fileLink,
                    whattodo: "delete_file",
                    fileName:file.response.fileName,
                    // flow_id:this.form.flow_id
                }
                this.axios.post(this.$root.rootUrl+'oa',datas
                ).then(function (res) {
                    window.console.log(res)

                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){

                            that.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            that.DeleteFromFileList(file)

                            that.DeleteFromFileList2(file)

                            let id=file.response.id

                            // console.log('id:',id)
                            console.log('that.form.fileList:',that.form.fileList)

                            console.log("this.$refs.upload.fileList:",that.$refs.upload.fileList)

                            let fileList=that.$refs.upload.fileList
                            let ind1=fileList.findIndex((value)=>value.response.id==id);
                            console.log("++++++++++++ind1:",ind1)
                            if(ind1!=-1){
                                that.$refs.upload.fileList.splice(ind1,1)
                            }


                            // console.log('that.fileList:',that.file_list)
                            // let ind1=that.file_list.findIndex((value)=>value.id==id);
                        
                            // if(ind1!=-1){
                            //     that.file_list.splice(ind1,1)
                            // }
                             
                            // that.form.fileList.splice(ind2,1)


                            // console.log('ind1:',ind1)
                            // console.log('ind2:',ind2)
                            // // that.form.fileList.splice(ind,1)

 
                        } else if (result.status=='fail'){
                            that.$message.error('删除失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });




            },


            InterestConflictCheck(){
                console.log('-----InterestConflictCheck----')
                var that=this
                var oppositeinfo=this.form.oppositeinfo 
                var arr=[]
                for(let p of oppositeinfo){
                    console.log("-------p:",p)
                    if (p.opposite_name){
                        arr.push(p.opposite_name)
                    }
                }
                //arr 对方当事人姓名数组
                var data= { 
                    whattodo: "interest_conflict_check",
                    // client_name:this.form.client_name,
                    oppositeinfo: arr ,//this.form.oppositeinfo,
                    mode:this.mode,
                    _id:this.$route.params.id ,
                    // client_isPerson:this.form.client_isPerson,
                    // client_identity:this.form.client_identity ||''
                }
                that.isallset=false
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        console.log('result:',result)
                        if(result.status=='ok'){
                            let data=result.data
                            if (data.length==0){
                                that.$message({
                                    message: '没有已存在的我方客户',
                                    type: 'success'
                                });
                            }else{
                                that.int_drawer=true
                                that.conflict_list=data

                                console.log("that.conflict_list:",that.conflict_list)
                            }
 
                        }else if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                        }
                        // if(result.status=='1'){
                        //     that.errMsg='该客户已被登记'

                        //     that.block=true
                        //     that.block_msg='该客户已被登记'

                        // }else{
                        //     that.errMsg='客户名称可登记'
                        //     that.block=false
                        //     that.block_msg=''
                        // }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });
            },


         
            handleChange(file, fileList) {
                console.log('handleChange   file:',file,"fileList:",fileList)
                this.file_list=fileList

                // console.log(t)
                console.log('this.$refs.upload',this.$refs.upload)

                // this.$refs.upload.fileList=fileList
            },



            remoteMethod(query) {

 
                // if (query !== '' && this.isallset) {
       
                //     this.loading = true;
                //     setTimeout(() => {
                //         this.loading = false;
                //         this.options = this.list.filter(item => {
                //         return item.label.toLowerCase()
                //             .indexOf(query.toLowerCase()) > -1;
                //         });
                //     }, 200);
                //     } else {
                //     this.options = [];

 
                // }

                if(query !== '' ){
                    this.SearchStaff(query)
                }

                // this.SearchStaff(query)

            },



            SearchStaff(keyword){
                var that=this
                var data= { 
                    whattodo: "search_staff",
                    keyword:keyword
                }
                that.isallset=false
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        console.log('result:',result)
                        if(result.status=='ok'){
                            let staff_arr=[]
                            let ind=0
                            for (let p of result.data){
                                // p.staff.label=p.staff.name
                                // p.staff.value=p.staff.name
                                // p.staff.ind=ind
                                // staff_arr.push(p.staff)
                                
                                p.label=p.name
                                p.value=p.name
                                p.ind=ind
                                staff_arr.push(p)

                                ind++
                            }
                            that.options=staff_arr
                            that.search_list=staff_arr

                            console.log('that.options:',that.options)

                            // that.list = that.options.map((item,index) => {
                            //     return { value: `value:${item.name}`, label: `${item.name}` ,"staff_id":item.staff_id ,"ind": index};
                            // });



                           

                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });



            },



            

            handleSelectConfirm() {
                window.console.log('handleSelectConfirm event ,this.selectValue:',this.selectValue)
                // if(this.selectValue){
                //     this.form.whoshare=this.selectValue
                // }

                // this.form.case_whoshare

                // if(!this.selectValue){
                //     this.onshowList=this.stafflist
                     
                // }

                // if(this.isallset){
                //     this.onshowList=[this.stafflist[this.selectValue.ind]]
                // }else{
                //     this.onshowList=[this.search_list[this.selectValue.ind]]
                // }
                // this.pageTotal=this.onshowList.length
                 
                

                // console.log('this.search_list:',this.search_list);

                 



                // let selectValue = this.selectValue;
                // if (selectValue) {
                //     this.procedure[index].staff.push(selectValue);
                // }
                // this.tempsig = false;
                // this.selectValue = '';
            },

            handleSelectConfirm2() {
                window.console.log('handleSelectConfirm event ,this.selectValue1:',this.selectValue1)
                // if(this.selectValue){
                   
                //      this.form.case_belong=this.selectValue1
                // }

 
            },
            


            
            CheckClientDetail(_id){
                let routeData = this.$router.resolve({name:"form", params: {mode:'check' ,template_id: '1001' ,  id: _id} });
                window.open(routeData.href, '_blank'); 
            },


            isImg(filename){
                //  return [
                //     '.png', '.jpg', '.jpeg', '.bmp', '.gif', '.webp', '.psd', '.svg', '.tiff'].
                //     indexOf(ext.toLowerCase()) !== -1;


                return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(filename);


            }


          


             

        }
	}
	
</script>

<style>
/* .el-menu{
    color:black;
} */
.tag_item{
    background-color: #eee7c0c4;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
    padding:0 0 0 10px;
    width:100%;
    display: flex;
    flex-direction: row;

    /* justify-content: space-between; */
    /* align-items: center; */
}

.line{
    text-align: right;
    padding-right:20px;
}

.affix_wrap{
    display:flex; 
    flex-direction:row;
    flex-wrap: wrap;
}

.affix_box{
    /* background-color: #fbfdff; */
    /* border: 1px solid #c0ccda; */
    /* border: 1px solid #1557a1; */

    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    /* height: 148px; */
    height: 178px;
    /* line-height: 146px; */
    /* vertical-align: top; */
    margin-left: 10px;

    cursor: pointer;
    display: flex;
    flex-direction: column;

}

.affix_box .up{
    height: 148px;
    width: 100;
}

.affix_box .down{
    height: 30px;
    width: 100%;
    /* border: 1px solid #c0ccda; */
    line-height: 30px;
    font-size:10px;
    overflow: hidden;
    text-align: center;
}

.affix_box img{
    width:100% ;
    /* max-height: 100%; */
}

.interest_conflict_style_box{
    width: 50%;
    height: 100%;
    /* border: 1px solid #c0ccda; */
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.interest_conflict_style{
    /* float:right; */
    line-height:8px;
    margin-right:15px; 
    cursor: pointer;
    /* border: 1px solid #c0ccda; */
    font-size: 14px;
    margin-top: auto;
    margin-bottom: auto;
    z-index: 999;
    
}

  .detail_dia{
    overflow-y: scroll;
    max-height: 90vh;
    border-radius: 5px;
 }


</style>
